import { Component, Input, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {UtilsService} from '../../../services/utils.service';
import {AuthService} from "../../../auth/auth.service";
import {CognitoService} from "../../../services/cognito.service";
import Swal from "sweetalert2";
declare var $: any;

@Component({
  selector: 'app-appmenu',
  templateUrl: './appmenu.component.html',
  styleUrls: ['./appmenu.component.css']
})
export class AppmenuComponent implements OnInit {

  @Input() userLogged: boolean;

  isMobile: boolean;
  rolId: string;
  rolName: string;
  classAdmin: string;
  classLeadAdmin: string;
  userInfo: any = {}
  permissions: any = [];
  permissionsDemos: boolean = false;
  permissionsCreditos: boolean = false;
  isClient: boolean = false;

  classShowAdmin: any;
  //classHideAdmin: any;
  classShowCliente: any;
  //classHideCliente: any;

  constructor(private router: Router, private utilsService: UtilsService,
              private auth: AuthService,
              private cognitoService: CognitoService) { }

  ngOnInit() {
    this.isClient = false
    this.currentUserFn()
    $('.has-treeview a').click(function(event) { event.preventDefault(); });
    $("#leftside-navigation .sub-menu > a").click(function(e) {
      $("#leftside-navigation ul ul").slideUp(), 
      $(this).next().is(":visible") || $(this).next().slideDown(),
      e.stopPropagation();
    });
  }

  permisosEspeciales(){
    if(this.userInfo['custom:permissions']) this.permissions = this.userInfo['custom:permissions'].split('|');
    if(this.permissions.length > 0)
    {
      if(this.permissions[4] == 2 || this.permissions[4] == 1) this.permissionsDemos = true;
      if(this.permissions[5] == 2 || this.permissions[5] == 1) this.permissionsCreditos = true;
    }
    if(this.rolId == '1') this.permissionsDemos = true;
  }

  onLogout() {
    this.cognitoService.signOut();
    localStorage.clear();
    window.location.href = '/login';
  }

  currentUserFn(){
    this.classShowAdmin = 'hide-admin';
    this.classShowCliente = 'hide-cliente';
    this.cognitoService.getCurrentUser().then((res) => {
      console.log(res)
      this.rolId = res.attributes['custom:userRole']
      if(this.rolId == 'cliente'){
        this.classShowAdmin = 'hide-admin';
        this.classShowCliente = 'show-cliente';
      }else{
        this.classShowAdmin = 'show-admin';
        this.classShowCliente = 'hide-cliente';
      }
    }).catch((err) => {
      console.log(err)
      Swal.fire('Error', 'Ocurrió un error al registrar el usuario.', 'error');
    })
  }
}
